import React from 'react';

export const SbRespTradeFreeShippingCoachmarkLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "SbRespTradeFreeShippingCoachmark" */ './SbRespTradeFreeShippingCoachmark'
    )
);
